module.exports = __webpack_public_path__ + "static/media/imagecandidates.9daedb77.png";